var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNextmineFlowerGold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-30 -30 60 60",
    width: 300,
    height: 300,
    role: "img",
    "aria-label": "Oldmine flower mark",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#cdbf9f",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-9 C6,-15 16,-9 12,-1 C20,-4 22,8 12,8 C16,17 4,20 0,11 C-4,20 -16,17 -12,8 C-22,8 -20,-4 -12,-1 C-16,-9 -6,-15 0,-9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-3 C3,-7 9,-4 6,1 C9,4 4,8 0,5 C-4,8 -9,4 -6,1 C-9,-4 -3,-7 0,-3 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 1,
    r: 2.6
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNextmineFlowerGold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nextmine-flower-gold.96c57394844f5c03b23a8dbba44c5048.svg";